// extracted by mini-css-extract-plugin
module.exports = {"root":"BrandLinks_root__wIy5S","item":"BrandLinks_item__uWD37"};